import axios from "axios";

export function updateScreenDisplayOrientation(token, body) {
    return axios.post(
        process.env.REACT_APP_API_URL + "/updateScreenDisplayOrientation",
        body,
        {
            headers: {
                Authorization: `${token}`,
            },
        },
    );
}
